import MotivatorsPageLayer from "@Motivators/layouts/MotivatorsPageLayer";
import MotivatorsWrapper from "@Motivators/layouts/MotivatorsWrapper";

import AE from "@/assets/icons/header/motivators/AE.svg";

const AutoAlertsView = MotivatorsPageLayer({
	WrappedComponent: MotivatorsWrapper,
	headerTitle: "Opportunity Mining",
	headerIcon: AE,
	motivatorType: "autoAlertsSetup",
});

export default AutoAlertsView;
